import React from "react";

const AddSelectableItem = ({ text = "Select item", onClick }) => {
  return (
    <div
      onClick={onClick}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "8px 0",
        cursor: "pointer",
      }}
    >
      <div
        style={{
          backgroundColor: "#F3F3F3",
          width: "28px",
          height: "28px",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: "600",
          fontSize: "12px",
          color: "#000",
        }}
      >
        +
      </div>
      <div style={{ fontWeight: 600, fontSize: "12px", color: "#000" }}>
        {text}
      </div>
    </div>
  );
};

export default AddSelectableItem;
